/**
 * Shophomira – small storefront helpers (loaded with `defer`, no dependencies).
 *  1. Delivery estimate  – [data-sh-delivery]        "Order today, delivered between Mon 6 Oct and Fri 10 Oct"
 *  2. Recently viewed    – [data-sh-recently-viewed] localStorage list of product handles (try/catch guarded)
 * Both re-run when Horizon morphs the product section on a variant change (MutationObserver).
 */
(function () {
  'use strict';

  /* ---------- 1. Delivery estimate (UK working days, weekends skipped) ---------- */
  var dateFormat = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });

  function addWorkingDays(start, days) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderDelivery(el) {
    if (el.dataset.shDone === '1') return;
    var min = parseInt(el.dataset.min, 10) || 5;
    var max = Math.max(parseInt(el.dataset.max, 10) || 10, min);
    var today = new Date();
    // en-GB → "Mon 6 Oct" (strip a comma in case a browser adds one)
    var from = dateFormat.format(addWorkingDays(today, min)).replace(',', '');
    var to = dateFormat.format(addWorkingDays(today, max)).replace(',', '');
    var tpl = el.dataset.template || 'Order today, delivered between <strong>[from]</strong> and <strong>[to]</strong>';
    var target = el.querySelector('[data-sh-delivery-text]');
    if (target) target.innerHTML = tpl.replace('[from]', escapeHtml(from)).replace('[to]', escapeHtml(to));
    el.dataset.shDone = '1';
  }

  /* ---------- 2. Recently viewed ---------- */
  var RV_KEY = 'sh:recently-viewed';
  var RV_MAX = 12;

  function readRV() {
    try {
      var v = JSON.parse(window.localStorage.getItem(RV_KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function writeRV(list) {
    try {
      window.localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, RV_MAX)));
    } catch (e) {
      /* storage unavailable (private mode / blocked) – ignore */
    }
  }

  function recordView(handle) {
    if (!handle) return;
    var list = readRV().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeRV(list);
  }

  function formatMoney(cents, format) {
    var fmt = format || '£{{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (cents / 100).toFixed(2);
    function withDelimiters(num, decimals, thousands, decimal) {
      var fixed = (num / 100).toFixed(decimals).split('.');
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fixed[1] ? whole + decimal + fixed[1] : whole;
    }
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return fmt.replace(match[0], value);
  }

  function renderRV(section) {
    if (section.dataset.shDone === '1') return;
    section.dataset.shDone = '1';
    var current = section.dataset.current;
    if (current) recordView(current);
    var limit = parseInt(section.dataset.limit, 10) || 4;
    var handles = readRV().filter(function (h) { return h !== current; }).slice(0, limit);
    if (!handles.length) return;
    var list = section.querySelector('[data-sh-rv-list]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image.replace(/^https?:/, '') : '';
        var sale = p.compare_at_price && p.compare_at_price > p.price;
        var price = '<span class="sh-rv__price' + (sale ? ' sh-rv__price--sale' : '') + '">' + formatMoney(p.price, section.dataset.moneyFormat) + '</span>' +
          (sale ? ' <s class="sh-rv__compare">' + formatMoney(p.compare_at_price, section.dataset.moneyFormat) + '</s>' : '');
        return '<li class="sh-rv__item"><a class="sh-rv__link" href="' + escapeHtml(p.url) + '">' +
          '<span class="sh-rv__media">' + (img ? '<img src="' + escapeHtml(img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600') + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="600" height="600">' : '') + '</span>' +
          '<span class="sh-rv__title">' + escapeHtml(p.title) + '</span>' +
          '<span class="sh-rv__prices">' + (p.available ? price : escapeHtml(section.dataset.soldOut || 'Sold out')) + '</span>' +
          '</a></li>';
      }).join('');
      if (html) {
        list.innerHTML = html;
        section.hidden = false;
      }
    });
  }

  /* ---------- init + re-init after Horizon morphs ---------- */
  function init(root) {
    (root || document).querySelectorAll('[data-sh-delivery]').forEach(renderDelivery);
    (root || document).querySelectorAll('[data-sh-recently-viewed]').forEach(renderRV);
  }

  init();

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      document.querySelectorAll('[data-sh-delivery]:not([data-sh-done="1"])').forEach(renderDelivery);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
